// extracted by mini-css-extract-plugin
module.exports = {"section":"TrustedBy_section__3pUeX","h3":"TrustedBy_h3__z8M6g","quote":"TrustedBy_quote__2kH1Y","text":"TrustedBy_text__1nx9W","figure":"TrustedBy_figure__26wZl"};